export const STATE_NAME = 'transactionsHistory';
export const prevTransactionInfoDismissed = 'prevTransactionInfoDismissed';
export const TRANSACTIONS_PER_PAGE = 10;
